<template>
  <b-container class="business-list">
    <h1 class="business-title">My Businesses</h1>

    <div
      v-if="loadingMerchantList"
      id="loader"
      class="page-loader loader-25">
      <div class="loading-circle mt-0"/>
    </div>
    <template v-if="!loadingMerchantList">
      <router-link
        :to="{ name: 'CreateMerchant' }"
        tag="div"
        class="business-list-merchant-box">
        <span class="business-list-logo add-business" />
        <span class="business-list-title">
          Create New Business Account
        </span>
      </router-link>

      <template v-if="merchantList && merchantList.length">
        <router-link
          v-for="merchant in merchantList"
          :key="merchant.id"
          :to="{ name: 'Merchant', params: { merchant_id: merchant.id }}"
          tag="div"
          class="business-list-merchant-box business-list-merchant-box--business"
          @click.native="setBusinessData(merchant)">
          <span
            class="business-list-logo"
            :style="merchant.logo ? `background-image: url(${merchant.logo});` : ''">
            <span
              v-if="userHasUnreadMessages(merchant)"
              class="has-unread-wrapper">
              <span class="has-unread">{{ userHasUnreadMessages(merchant) }}</span>
            </span>
          </span>
          <div class="business-list-title">
            {{ merchant.name }}
          </div>
          <BusinessDropdown
            :merchant="merchant"
            @click.native="setMerchantPartialData(merchant)"/>
        </router-link>
      </template>
    </template>

    <InfoModal
      v-if="successMessage"
      ref="infoModal"
      :message="successMessage"/>
    <InfoModal
      v-if="errorMessage"
      ref="errorModal"
      :message="errorMessage"/>
  </b-container>
</template>

<style lang="scss" src="@/assets/css/modules/_business-list.scss" scoped></style>

<script>
import { mapActions, mapGetters } from 'vuex';
import { injectScript } from '@/helpers/scriptInjection';
import InfoModal from '../common/modals/InfoModal';
import BusinessDropdown from './BusinessDropdown';

export default {
  name: 'BusinessList',
  components: {
    InfoModal,
    BusinessDropdown,
  },
  data() {
    return {
      successMessage: '',
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      loadingMerchantList: 'merchant/loadingMerchantList',
      merchantList: 'merchant/merchantList',
      invitationAccepted: 'user/invitationAccepted',
      onesignalAppId: 'system/onesignalAppId',
      apiError: 'user/apiError',
    }),
  },
  watch: {
    invitationAccepted(accepted) {
      if (accepted) {
        this.successMessage = 'The invitation has been successfully accepted.';
        this.fetchMerchantRoles();
        this.fetchMerchants();
        // this.fetchMerchantSubscriptions();
        this.$nextTick(() => {
          this.$refs.infoModal.show();
        });
      }
    },
    apiError(error) {
      if (error.status === 422) {
        this.errorMessage = error.data.errors.invite_token[0];
      } else if (error.data) {
        this.errorMessage = error.data.message;
      }

      this.$nextTick(() => {
        this.$refs.errorModal.show();
      });
    },
  },
  mounted() {
    this.fetchMerchants();

    if (this.$route.query.invite_token) {
      this.acceptMerchantInvitation({ invite_token: this.$route.query.invite_token });
    }
    this.fetchMerchantRoles();
    // this.fetchMerchantSubscriptions();

    // if (!window.OneSignal && this.$env.NODE_ENV === 'production') {
    if (!window.OneSignal) {
      injectScript('OneSignal', 'https://cdn.onesignal.com/sdks/OneSignalSDK.js', true).then(() => this.configureOneSignal());
    }
  },
  methods: {
    ...mapActions({
      fetchMerchants: 'merchant/fetchMerchants',
      setMerchantPartialData: 'merchant/setMerchantPartialData',
      fetchMerchantRoles: 'user/fetchMerchantRoles',
      acceptMerchantInvitation: 'user/acceptMerchantInvitation',
      // fetchMerchantSubscriptions: 'merchant/fetchSubscriptions',
      setOneSignalId: 'user/setOneSignalId',
      removeOneSignalId: 'user/removeOneSignalId',
      // turnOffEchoConnection: 'pusher/turnOffEchoConnection',
    }),
    setBusinessData(merchant) {
      this.setMerchantPartialData(merchant);
    },
    userHasUnreadMessages(merchant) {
      if (this.$lodash.isEmpty(merchant.unread_conversations)) {
        return false;
      }

      // returns boolean, number or string(if > 99)
      return merchant.unread_conversations.all_unread ? (merchant.unread_conversations.all_unread < 100 ? merchant.unread_conversations.all_unread : '99+') : false;
    },
    configureOneSignal() {
      // console.log('ONE SIGNALLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL ' + onesignalAppId); // TODO transfer OneSignal to org component so it gets initialized
      const OneSignal = window.OneSignal;
      OneSignal.push(() => {
        OneSignal.init({
          // appId: this.$env.VUE_APP_ONESIGNAL_APP_ID,
          appId: this.onesignalAppId,
        });
        OneSignal.getUserId((oneSignalId) => {
          if (oneSignalId) {
            this.setOneSignalId({ onesignal_uid: oneSignalId });
          }
        });
        OneSignal.on('subscriptionChange', (isSubscribed) => {
          if (isSubscribed) {
            OneSignal.getUserId((oneSignalId) => {
              this.setOneSignalId({ onesignal_uid: oneSignalId });
            });
          } else {
            OneSignal.getUserId((oneSignalId) => {
              this.removeOneSignalId(oneSignalId);
            });
          }
        });
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm.turnOffEchoConnection();
    });
  },
};
</script>
